// components/shared/AuthWrapper/AuthWrapper.jsx
import React from "react";
import { Outlet } from "react-router-dom";
import useAuthSync from "../../../hooks/useAuthSync";

export default function AuthWrapper() {
  useAuthSync(true); // start auth-sync if creds exist
  return <Outlet />; // <-- renders the matched child route
}
